import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CollectiveDataProvider } from '../_providers/collective-data-provider';

@Injectable({
  providedIn: 'root'
})
export class PublicRedirectionGuard implements CanActivate  {

  public collectiveConfig = null;

  constructor (
    private router: Router,
    private collectiveDataProvider: CollectiveDataProvider 
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.collectiveDataProvider.getData().subscribe((c: {}) => {
      this.collectiveConfig = c;
      if (!environment.protected && this.collectiveConfig.active == 0) {
        return true;
      }
      if (!environment.protected && this.collectiveConfig.active == 1) {
        this.router.navigateByUrl('service-index');
        return false;
      }
    });
    return true;
  }
}
